import { render, staticRenderFns } from "./access-denied.vue?vue&type=template&id=4bbf2002&"
import script from "./access-denied.vue?vue&type=script&lang=ts&"
export * from "./access-denied.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports